<template>
  <div>
    <BaseModal
      class="upload-modal"
      id="file-selector"
      v-model="isOpenModal"
      :allowClose="true"
    >
      <div class="file-uploader">
        <div class="body" v-if="!processingFile">
          <div class="tabs" v-if="showTabs">
            <a
              @click="side = 'uploaded'"
              :class="{ selected: side == 'uploaded' }"
              >Uploaded File</a
            >
            <a @click="side = 'new'" :class="{ selected: side == 'new' }"
              >Upload File</a
            >
          </div>
          <div class="content images" v-if="side == 'uploaded' && showTabs">
            <div class="images-display w-full justify-center">
              <div
                class="image"
                v-for="img in existingFiles"
                :key="img.id"
                :class="{ selected: selectedFile && selectedFile.id == img.id }"
                @click="selectedFile = img"
              >
                <img :src="img.s3Url" />
              </div>
            </div>
            <button
              class="btn-dark-button"
              v-if="selectedFile"
              @click="confirmSelection()"
            >
              Confirm selection
            </button>
          </div>
          <div class="block justify-center" v-if="side == 'new' || !showTabs">
            <template v-if="!uploadedFile">
              <div class="mx-auto">
                <input type="file" id="file" @change="onFileChanged" />
                <label for="file" class="btn-2">Select file</label>
              </div>
            </template>
            <div class="responses">
              <p
                v-for="(res, index) in fileUploadResponse"
                :key="index"
                v-html="res"
              />
              <ul v-if="UploadActions && UploadActions.length > 0">
                <li
                  v-for="(res, index) in UploadActions"
                  :key="index"
                  v-html="res"
                />
                <template v-if="filesGenerated && filesGenerated.length > 0">
                  <li v-for="(file, index) in filesGenerated" :key="index">
                    <button
                      class="btn-dark-button"
                      @click="downloadFile(file.route)"
                    >
                      Download "{{ file.name }}" file
                    </button>
                  </li>
                </template>
              </ul>
            </div>
          </div>
        </div>
        <div v-else>
          <BaseSmallSpinner />
        </div>
      </div>
    </BaseModal>
  </div>
</template>
<script>
import {
  signAndDownloadFile,
  getUploadOptions,
  uploadFileService,
  getFilesUploaded
} from "@/api/store/UploadFilesService.js";

export default {
  props: {
    value: {
      type: Boolean,
      required: true
    },
    type: {
      type: [String, Boolean],
      required: false,
      default: false
    },
    subcategory: {
      type: [String, Boolean],
      required: false,
      default: false
    },
    extra: {
      type: [String, Boolean],
      required: false,
      default: false
    },
    uploadOnly: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      side: "new", // Cambio por defecto a 'new'
      processing: false,
      isOpenModal: this.value,
      uploadOptions: [],
      newFile: [],
      processingFile: false,
      formValues: {
        fileType: "",
        otherOptions: {}
      },
      otherFormOptions: null,
      fileUploadResponse: [],
      UploadActions: [],
      filesGenerated: [],
      existingFiles: [],
      uploadedFile: false,
      selectedFile: null
    };
  },
  computed: {
    showTabs() {
      return !this.uploadOnly;
    },
    isOpen() {
      return this.value;
    },
    formValuesValid() {
      if (this.formValues.fileType != "") {
        return {
          valid: true,
          message: ""
        };
      } else {
        return {
          valid: false,
          message: "Type of file no selected"
        };
      }
    },
    description() {
      if (this.formValues?.fileType) {
        let desc = this.uploadOptions.find(
          x => x.value == this.formValues.fileType
        );
        desc = desc.description || "";
        return desc;
      } else {
        return "";
      }
    }
  },
  watch: {
    isOpenModal(val) {
      this.$emit("input", val);
    },
    value(val) {
      if (val && this.showTabs) {
        this.loadImages();
      }
      if (val) {
        this.uploadedFile = false;
        this.selectedFile = null;
        // Si es uploadOnly, empezar en 'new'
        this.side = this.uploadOnly ? "new" : "uploaded";
      }
      this.isOpenModal = val;
    },
    formValues: {
      deep: true,
      handler() {
        this.fileUploadResponse = [];
      }
    }
  },
  mounted() {
    if (this.type == false) {
      this.uploadOptions = getUploadOptions();
    } else {
      this.formValues.fileType = this.type;
      if (this.type == "assets") {
        this.formValues.otherOptions = {
          assetsType: this.subcategory
        };
      }
    }
    // Si es uploadOnly, empezar en 'new'
    this.side = this.uploadOnly ? "new" : "uploaded";
  },
  methods: {
    confirmSelection() {
      this.$emit("selectedFile", this.selectedFile);
      this.isOpenModal = false;
    },
    async loadImages() {
      if (this.showTabs) {
        this.existingFiles = await getFilesUploaded(
          this.type,
          this.subcategory
        );
      }
    },
    async downloadFile(key) {
      console.log("s3Path", key);
      const res = await signAndDownloadFile(key);
      console.log("res", res);
      if (!res) {
        this.$toast.open({
          message: `Error Downloading file`,
          type: "error",
          position: "top-right"
        });
      }
      return;
    },
    LoadOtherOptions() {
      this.formValues.otherOptions = {};
      this.otherFormOptions = null;
      const otherOptionsSet = this.uploadOptions.find(
        x => x.value == this.formValues.fileType
      );
      if (otherOptionsSet?.otherOptions) {
        this.otherFormOptions = otherOptionsSet.otherOptions;
        otherOptionsSet.otherOptions.forEach(t => {
          this.formValues.otherOptions[t.inputId] = null;
        });
      }
    },
    onFileChanged() {
      var fileList = [];
      for (var i = 0; i < event.target.files.length; i++) {
        fileList.unshift(event.target.files[i]);
      }
      this.newFile = fileList;
      this.fileUploadResponse = [];
      this.UploadActions = [];
      this.submitUploadFile();
    },
    submitUploadFile() {
      this.UploadActions = [];
      this.fileUploadResponse = [];
      this.processingFile = true;
      if (
        this.newFile &&
        this.newFile.length > 0 &&
        this.formValuesValid.valid
      ) {
        this.uploadFile(this.newFile)
          .then(res => {
            console.log("submit upload file completed");
            this.newFile = null;

            // Emitir información completa del archivo
            const fileInfo = {
              fileName: res.upload.fileName || res.upload.originalName,
              url: res.upload.s3Url,
              s3Key: res.upload.s3Key || res.upload.key,
              ...res.upload
            };

            this.$emit("fileUploaded", fileInfo);

            if (this.showTabs) {
              this.existingFiles.push(res.upload);
            }
            this.processingFile = false;

            // Si es uploadOnly, cerrar el modal automáticamente
            if (this.uploadOnly) {
              this.isOpenModal = false;
            }
          })
          .catch(() => {
            console.log("error on upload catch");
            this.processingFile = false;
          })
          .finally(() => {
            this.newFile = null;
          });
      } else {
        this.processingFile = false;
        if (!this.newFile || this.newFile.length == 0) {
          this.fileUploadResponse.push(`No file selected`);
        }
        if (!this.formValuesValid.valid) {
          this.fileUploadResponse.push(this.formValuesValid.message);
        }
        return;
      }
    },
    uploadFile(file) {
      if (this.type == "assets") {
        this.formValues.otherOptions.assetsType = this.subcategory;
      }
      if (this.extra) {
        this.formValues.otherOptions.extra = this.extra;
      }
      return uploadFileService(file, this.formValues)
        .then(res => {
          const uploadedFile = res.upload || null;
          if (res.status == "success") {
            this.$toast.open({
              message: `${res.message}`,
              type: "success",
              position: "top-right"
            });
          }
          if (res.status == "error") {
            this.$toast.open({
              message: `${res.message}`,
              type: "error",
              position: "top-right"
            });
          }
          this.$emit("uploadedFile", uploadedFile);
          this.fileUploadResponse.push(`${res.message}`);
          this.UploadActions = res.actions || [];
          this.filesGenerated = res.filesGenerated || [];
          this.uploadedFile = true;
          return res;
        })
        .catch(e => {
          if (e.response) {
            this.fileUploadResponse.push(`${e.response}`);
          } else {
            this.fileUploadResponse.push(`Error Uploading file`);
          }
          throw e;
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.upload-modal {
  .modal-content {
    max-width: 550px;
    max-height: 80vh;
    overflow-y: auto;
    .file-uploader {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      .body {
        width: 100%;
        display: flex;
        flex-direction: column;
        text-align: center;
        min-height: 250px;
        .tabs {
          display: grid;
          grid-template-columns: auto auto;
          width: fit-content;
          margin: 0 auto;
          grid-gap: 20px;
          margin-bottom: 20px;
          a {
            &.selected {
              border-bottom: 3px solid red;
            }
          }
        }
        .content.upload {
          justify-content: center;
          align-items: center;
          flex-direction: column;
        }
        .content.images {
          display: flex;
          flex-direction: column;
          justify-content: center;
          .images-display {
            max-height: 600px;
            overflow-y: auto;
            overflow-x: hidden;
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            justify-content: center;
            .image {
              width: 100px;
              padding: 5px;
              border: 1px solid gray;
              border-radius: 4px;
              margin: 2px;
              &.selected {
                border: solid 2px #0088ff;
                -webkit-box-shadow: 0px 0px 8px 0px #0088ff;
                -moz-box-shadow: 0px 0px 8px 0px #0088ff;
                box-shadow: 0px 0px 8px 0px #0088ff;
              }
              img {
                width: 100%;
              }
            }
          }
          button {
            width: 200px;
            margin: 15px auto;
          }
        }
        .other-inputs {
          margin-top: 40px;
          display: grid;
          grid-gap: 20px;
          grid-template-columns: repeat(2, minmax(0, 1fr));
          div {
            display: flex;
          }
        }
      }
      .footer {
        width: 100%;
        text-align: left;
        font-size: 12px;
      }
      h2 {
        font-weight: 700;
        font-size: 20px;
        width: 100%;
        text-align: center;
      }
      #upload-btn {
        width: 80px;
        margin: 40px auto;
      }
      .input-box {
        width: 250px;
        margin: 20px auto;
        input {
          text-align: center;
        }
      }
    }
  }
}
</style>
<style lang="scss" scoped>
[type="file"] {
  height: 0;
  overflow: hidden;
  width: 0;
}

[type="file"] + label {
  background: #f15d22;
  border: none;
  border-radius: 5px;
  color: #fff;
  cursor: pointer;
  display: inline-block;
  font-size: inherit;
  font-weight: 500;
  margin-bottom: 1rem;
  outline: none;
  padding: 1rem 50px;
  position: relative;
  transition: all 0.3s;
  vertical-align: middle;

  &.btn-2 {
    background-color: #99c793;
    border-radius: 50px;
    overflow: hidden;

    &:hover {
      background-color: darken(#99c793, 30%);

      &::before {
        right: 75%;
      }
    }
  }
}
</style>
